import { WrapLgMarginBottom } from "App/global-style";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { HUSEIERNE_HOUSE_CONTENTS_DEDUCTIBLE } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/huseierneHouseContentsConstants";
import { HuseierneHouseContentsProductPriceFormValues } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/huseierneHouseContentsFormValuesInterfaces";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { DittoCoverageCard } from "Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import React from "react";

interface HuseierneHouseContentsCoveragesProps {
  formProps: FormikProps<HuseierneHouseContentsProductPriceFormValues>;
}

export const HuseierneHouseContentsCoverages = ({
  formProps,
}: HuseierneHouseContentsCoveragesProps): React.ReactElement => {
  const { huseiernehousecontents: productCardTexts } =
    getCollectionOfDittoComponents(TextComponentNameLevel1.COVERAGE_CARD);
  const [selectedCoveragePriceCalculation] = useCoveragePriceCalculations();
  return (
    <WrapLgMarginBottom>
      {isDefined(selectedCoveragePriceCalculation) && (
        <DittoCoverageCard
          fieldName="coverage"
          product={ProductBackendName.HUSEIERNE_HOUSE_CONTENTS}
          coverage={selectedCoveragePriceCalculation[0]}
          textComponents={productCardTexts}
          prices={selectedCoveragePriceCalculation[1].prices}
          hideRadioButton
        />
      )}
      <CurrentPriceMessage
        productBackendName={ProductBackendName.HUSEIERNE_HOUSE_CONTENTS}
        coverages={[selectedCoveragePriceCalculation]}
        selectedPrices={[
          {
            selectedCoverage: formProps.values.coverage,
            selectedDeductible: undefined,
            defaultDeductible: HUSEIERNE_HOUSE_CONTENTS_DEDUCTIBLE,
          },
        ]}
      />
    </WrapLgMarginBottom>
  );
};
